<!--
 * @Descripttion: 查看已完结订单明细-项目费用 => 个人&个体&供应商子集
 * @Date: 2024-08-06 13:58:47
-->
<template>
  <div class="order-detail-c">
    <BaseButton
      v-if="detailInfo.needBack === 1"
      link
      :icon="ArrowLeft"
      @click="onBack"
    >
      返回
    </BaseButton>
    <xrk-table
      style="height: 650px"
      ref="xrkTableRef"
      :getListAjax="getListAjax"
      :searchConfig="searchConfig"
      :tableConfig="tableConfig"
    ></xrk-table>
  </div>
</template>

<script lang="tsx" setup>
import { ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { ArrowLeft } from '@element-plus/icons-vue';
import {
  XrkTable,
  XrkTableProps,
  XrkTableRef,
  useTableColumn,
  BaseButton
} from 'xrk-components';

import { orderDetail } from '../data-source/apis';
import {
  indexCol,
  individualNameCol,
  fullNameCol,
  phoneCol,
  settlementTaskCountCol,
  taskPriceCol,
  projectPayPriceCol,
  orderPriceCol,
  payStatusCol,
  endPointFinishPayAtCol,
  deductIndividualTaxAmountCol,
  paidOrderAmountCol,
  parkNameCol
} from '../fields/columns';
import {
  individualNameSearch,
  fullNameSearch,
  phoneSearch,
  payStatusSearch,
  parkNameSearch
} from '../fields/searchs';
import { ORDER_PAY_STATUS_PAY_SUCCESS } from '../constants';
import {
  batchDownLoadReceipt,
  downLoadReceipt
} from '@/common/hooks/order/order-download';

const route = useRoute();
const router = useRouter();
const onBack = () => {
  router.go(-1);
};
const detailInfo = computed(() => {
  return {
    aspSupplierOrderId: +route.query.aspSupplierOrderId,
    projectStructureType: +route.query.projectStructureType, //是否是个体
    aspOrderId: +route.query.aspOrderId,
    needBack: +route.query.needBack || 0, //是否需要返回按钮
    isSupplierOrder: +route.query.isSupplierOrder || 0 //是否从供应商查看明细进入
  };
});

const xrkTableRef = ref<XrkTableRef>();

const isGeti = computed(() => {
  return detailInfo.value.projectStructureType === 2;
});

// 搜索项
const searchConfig = computed<XrkTableProps['searchConfig']>(() => {
  return {
    searchBtn: {
      show: true,
      text: '搜索'
    },
    resetBtn: {
      show: true,
      text: '重置'
    },
    searchColumns: [
      isGeti.value && individualNameSearch,
      isGeti.value && parkNameSearch,
      { ...fullNameSearch, label: isGeti.value ? '经营者' : '终端服务人员' },
      phoneSearch,
      detailInfo.value.isSupplierOrder !== 1 && {
        ...payStatusSearch,
        config: {
          options: ORDER_PAY_STATUS_PAY_SUCCESS
        }
      }
    ].filter(Boolean),
    otherComponents: [
      // 四级结构不展示回单
      detailInfo.value.isSupplierOrder !== 1 && {
        render() {
          return (
            <>
              <BaseButton
                type="primary2"
                onClick={async () => {
                  //批量下载回单
                  await batchDownLoadReceipt({
                    downloadType: 504,
                    downloadList: [
                      {
                        id:
                          detailInfo.value.aspOrderId ||
                          detailInfo.value.aspSupplierOrderId,
                        aspOrderId: detailInfo.value.aspOrderId,
                        aspSupplierOrderId: detailInfo.value.aspSupplierOrderId,
                        orderType: 1
                      }
                    ]
                  });
                }}
              >
                批量下载回单
              </BaseButton>
            </>
          );
        }
      }
    ].filter(Boolean)
  };
});

// 列表
const tableConfig = computed<XrkTableProps['tableConfig']>(() => {
  return {
    tableColumns: [
      indexCol,
      isGeti.value && individualNameCol,
      isGeti.value && parkNameCol,
      { ...fullNameCol, label: isGeti.value ? '经营者' : '终端服务人员' },
      phoneCol,
      settlementTaskCountCol,
      taskPriceCol,
      projectPayPriceCol,
      orderPriceCol,
      route.meta.taxType === 2 && deductIndividualTaxAmountCol,
      route.meta.taxType === 2 && paidOrderAmountCol,
      detailInfo.value.isSupplierOrder !== 1 && {
        ...payStatusCol,
        formatter({ cellValue }) {
          return ORDER_PAY_STATUS_PAY_SUCCESS?.[cellValue]?.label || '-';
        }
      },
      endPointFinishPayAtCol,
      // 四级结构不展示回单
      detailInfo.value.isSupplierOrder !== 1 &&
        useTableColumn({
          align: 'center',
          fixed: 'right',
          label: '操作',
          width: 230,
          render({ row }) {
            return (
              <>
                <div>
                  <BaseButton
                    disabled={!row.receiptUrl || row.receiptUrl === '-'}
                    onClick={async () => {
                      // 下载回单
                      downLoadReceipt(row.receiptUrl);
                    }}
                    type="text"
                  >
                    下载回单
                  </BaseButton>
                </div>
              </>
            );
          }
        })
    ].filter(Boolean)
  };
});

const getListAjax = async params => {
  const reqData = {
    ...params,
    aspSupplierOrderId: detailInfo.value.aspSupplierOrderId,
    projectStructureType: detailInfo.value.projectStructureType,
    aspOrderId: detailInfo.value.aspOrderId
  };
  const data = await orderDetail(reqData);
  return data;
};
</script>
<style lang="scss"></style>
